import '../assets/cssFiles/footer.css';

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const  Footer = (props) => {
    const [ hoverItem, setHoverItem ] = useState(-1);
    return(
        <footer className="copy">
            <div className="container">
                <div className="left fl-lf">
                    <div className="fs-26" style={{fontWeight: "bold",margin:'120px 0 10px'}}>友情链接</div>
                    <div className="link hover-style">
                        <a target='blank' href="http://www.moe.gov.cn">中华人民共和国教育部</a>
                        <a target='blank' href="http://edu.people.com.cn">人民网教育</a>
                        <a target='blank' href="https://www.chsi.com.cn">中国高等教育学生信息网</a>
                    </div>
                    <div className="link hover-style">
                        <a target='blank' href="https://gaokao.chsi.com.cn">阳光高考</a>
                        <a target='blank' href="https://www.zjzs.net/moban/index/index.html">浙江省教育考试院</a>
                        <a target='blank' href="https://zhejiang.eol.cn">中国教育在线浙江</a>
                        <a target='blank' href="http://www.hdu.edu.cn">杭州电子科技大学</a>
                    </div>
                </div>
                <div className="right fl-lf">
                    <div className="contact-info">
                        { hoverItem === -1 || hoverItem === "right" ? 
                            <img src={require('../assets/images/footer-1.png')} alt="" onMouseEnter={()=>(setHoverItem("left"))}/>
                        :
                            <img src={require('../assets/images/footer-1-1.png')} alt="" onMouseLeave={()=>(setHoverItem(-1))}/>
                        }
                        { hoverItem === -1 || hoverItem === "left" ? 
                            <img src={require('../assets/images/footer-2-1.png')} alt="" onMouseEnter={()=>(setHoverItem("right"))}/>
                        :
                            <img src={require('../assets/images/footer-2.png')} alt=""  onMouseLeave={()=>(setHoverItem(-1))}/>
                        }
                        { hoverItem === -1 ? null : hoverItem === "left" ? 
                            <img alt="" src={require('../assets/images/footer-1-2.png')} style={{position: "absolute",left: -27,top: -125}}/>
                        :
                            <img alt="" src={require('../assets/images/footer-2-2.png')} style={{position: "absolute",left: 50,top: -125}}/>
                        }
                    </div>
                    <div className="lead hover-style line-height-32">
                        <a target="blank" href={`${window.location.origin}/five`}>五大模块</a><span>|</span>
                        <a target="blank" href={`${window.location.origin}/three`}>三大群体</a><span>|</span>
                        <a target="blank" href={`${window.location.origin}/contact`}>最新资讯</a><span>|</span>
                        <a target="blank" href={`${window.location.origin}/about`}>关于我们</a><span>|</span>
                        <a target="blank" href={`${window.location.origin}/partnership`}>合伙人计划</a>
                    </div>
                    <div className="line-height-32"><span className="hand" onClick={()=>{window.open("https://beian.miit.gov.cn/#/Integrated/index")}}>浙ICP备14002474号-3</span>Copyright2012-{(new Date()).getFullYear()}&nbsp;&nbsp;杭州达言科技有限公司&nbsp;&nbsp;版权所有</div>
                </div>
            </div>
        </footer>
    )
}

export default  Footer;